import { coordinateLookup } from 'backend/coordinateLookup.jsw'
import wixWindow from 'wix-window';
import wixLocation from 'wix-location'

$w.onReady(async function () {

	//check query params to see if need to scroll to custom element
	if(wixLocation.query.hasOwnProperty('redeem_online')) {
		$w('#CustomElement1').scrollTo()
	}
	
	let geoLocation;
	try {
		geoLocation = await wixWindow.getCurrentGeolocation();
	} catch(error) {
		console.log(error, "error getting data")
	}

	let resolvedCountryCode = null;
	if (geoLocation) {
		let longitude = geoLocation.coords.longitude
		let latitude = geoLocation.coords.latitude
		console.log(longitude, latitude)
		await coordinateLookup(latitude, longitude).then((response) => { //Italy 41.8719,12.5674 //France 46.2276, 2.2137
			let countryCode = response.results[0].components["ISO_3166-1_alpha-2"];
			console.log('geo:' + countryCode);

			if (countryCode === "UA" || countryCode === "IE" || countryCode === "NZ" || countryCode === "CA" || countryCode === "IT" || countryCode === "ES" || countryCode === "DE" || countryCode === "FR" || countryCode === "NL") {	
				resolvedCountryCode = countryCode.toLowerCase();
			} else if (countryCode === 'US' || countryCode === 'IL') {
				resolvedCountryCode = 'us';
			} else {
				resolvedCountryCode = 'uk';
			}
		}).catch(()=> {});
	} 
	if (!resolvedCountryCode) resolvedCountryCode = 'uk';
	$w('#CustomElement1').setAttribute('geo', resolvedCountryCode);
});
